//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/other/Button'
import Loader from '~/components/other/Loader'
import CompilationsList from "~/components/compilations/CompilationsList"
import CompilationSliderForMobile from "~/components/compilations/CompilationSliderForMobile"
import {getContentByCode} from "@/utils/utils";

export default {
  components: {
    CompilationsList,
    CompilationSliderForMobile,
    Button,
    Loader
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    startCount: {
      type: Number,
      required: false,
      default: 4
    },
    addCount: {
      type: Number,
      required: false,
      default: 4
    },
    view: {
      type: String,
      required: false,
      default: 'v'
    },
    textFoAllComp: {
      type: String,
      required: false,
      default: `Все подборки<br>раздела`
    }
  },
  inject: ['$isMobile'],
  data() {
    return {
      pageSize: 4,
      currentPage: 1,
      items: [],
      loading: false,
      itemsCountForMobile: 8
    }
  },
  computed: {
    isMobile () {
      return this.$isMobile()
    },
    fetchItems() {
      return this.getItems?.data?.data?.items || []
    },
    allRecordCount() {
      return this.getItems?.data?.data?.allRecordCount || 0
    },
    pageCount() {
      return this.getItems?.data?.data?.pageCount || 0
    }
  },
  async mounted() {
    this.items = await this.fetchItems
  },
  methods: {
    addItems () {
      this.loading = true
      this.currentPage++
    },
    rollUp () {
      const sectionTop = `section-${this.section.id}`
      this.$scrollToTop(sectionTop, 300, 100)
      this.currentPage = 1
    },
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  chimera: {
    getItems () {
      return {
        url: `/api/compilation/items/`,
        key: `compilation-items-${this.section.id}-${this.currentPage}-${this.$i18n.locale}`,
        debounce: 1000,
        params: {
          lang: this.$i18n.locale || 'ru',
          page_size: !this.isMobile ? this.pageSize : this.itemsCountForMobile,
          page: this.currentPage,
          section_id: this.section.id
        },
        on: {
          success () {
            if(this.getItems?.data?.data?.items) {
              if(this.currentPage > 1) {
                this.items = this.items.concat(this.getItems.data.data.items)
                setTimeout(()=> {
                  const sectionTop = `comp-item-${this.section.id}-${this.currentPage * this.pageSize - this.pageSize}`
                  this.$scrollToTop(sectionTop, 300, 30)
                }, 50)
              } else {
                this.items = this.getItems.data.data.items
              }
              this.loading = false
            } else {
              this.items = []
            }
          }
        }
      }
    },
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'comp-section-texts',
        auto: true,
        params: {
          code: ['podborki-show-more', 'podborki-hide'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
